/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateJoinRequestsRead.defs.js'
export { main as default } from './updateJoinRequestsRead.defs.js'
